import React, { useEffect, useState } from "react";
import LoadCSSforfirstTime from "../../../../CloudStorage/LoadCSSforfirstTime";
import ActiveContest from "./ContestTab/ActiveContest";
import CompletedContest from "./ContestTab/CompletedContest";
import { useDispatch, useSelector } from "react-redux";
import { getMinePosts, getPostCounts } from "../../../../redux/posts/action";
import { useRouteBaseStateContext } from "../../../../Context/RouteBaseStateContext";
import CancelledContests from "./ContestTab/CancelledContests";

export default function ManageContest() {
  const { urlstate, setManageworkContestroute } = useRouteBaseStateContext();

  const [activeTab, setActiveTab] = useState("Activecontests"); // State to track active tab
  const dispatch = useDispatch();
  const postlistmine = useSelector(
    ({ posts: { postlistmine } }) => postlistmine,
  );
  const postcounts = useSelector(({ posts: { postcounts } }) => postcounts);
  const path = "Assets/scss/myorders.module.scss";

  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);

  useEffect(() => {
    dispatch(getPostCounts(4));
  }, [dispatch]);

  useEffect(() => {
    if (urlstate?.manageworkcontestroute) {
      setActiveTab(urlstate?.manageworkcontestroute || "Activecontests");
    } else {
      setActiveTab("Activecontests");
    }
  }, [urlstate, urlstate?.manageworkcontestroute]);

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    setManageworkContestroute(tab);
  };

  return (
    <div className="order-section manage-contest">
      <div className="tab-sec">
        <div className="order-first flex-column align-items-start" style={{rowGap:'24px'}}>
          <h2>Manage Win business Opportunities (WBO)</h2>
          <ul className="nav nav-tabs">
            <li className="nav-item">
              <a
                className={`nav-link ${activeTab == "Activecontests" ? "active" : ""}`}
                onClick={() => handleTabClick("Activecontests")}
              >
                Active Win business Opportunities (WBO) ({postcounts?.active})
              </a>
            </li>
            <li className="nav-item">
              <a
                className={`nav-link ${activeTab == "Completedcontests" ? "active" : ""}`}
                onClick={() => handleTabClick("Completedcontests")}
              >
                Completed Win business Opportunities (WBO) ({postcounts?.completed})
              </a>
            </li>
            <li className="nav-item">
              <a
                className={`nav-link ${activeTab == "Cancelledcontests" ? "active" : ""}`}
                onClick={() => handleTabClick("Cancelledcontests")}
              >
                Cancelled Win business Opportunities (WBO) ({postcounts?.cancelled})
              </a>
            </li>
          </ul>
        </div>
        <div className="tab-content">
          <div
            className={`tab-pane ${activeTab == "Activecontests" ? "active" : ""}`}
            id="Activecontests"
          >
            <ActiveContest />
          </div>
          <div
            className={`tab-pane ${activeTab == "Completedcontests" ? "active" : ""}`}
            id="Completedcontests"
          >
            <CompletedContest />
          </div>
          <div
            className={`tab-pane ${activeTab == "Cancelledcontests" ? "active" : ""}`}
            id="Cancelledcontests"
          >
            <CancelledContests />
          </div>
        </div>
      </div>
    </div>
  );
}
